import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as yup from 'yup';

import { api, useAPIContext } from '../../api/context';
import { Title } from '../../utils/title';
import toast from '../../utils/toast';
import Layout from './Layout';
import styles from './_01_Email.module.scss';

const _01_Email = () => {

  const [ loading, setLoading ] = useState(false);
  const [ params, setParams ] = useSearchParams();

  const email = params.get('email');

  const navigate = useNavigate();

  useEffect(() => {
    if (!email) {
      navigate('/');
    }
  }, [email, navigate]);

  const { setToken } = useAPIContext();

  const next = () => {

    const TARGET = '/wizard/phone';

    if (window._PASSWORD) {

      setLoading(true);

      api().v1.auth.login
        .post({
          email,
          password: window._PASSWORD,
        })
        .then(res => {
          window._PASSWORD = undefined;
          setLoading(false);

          if (res.status === 200) {
            setToken(res.body.token);
            navigate(TARGET);
          }

          if (res.status === 400) {
            toast.show(toast.KIND.ERROR, res.body);
          }
        })
        .catch(err => {
          window._PASSWORD = undefined;
          setLoading(false);
          toast.show(toast.KIND.WARNING, err);
        });

    } else {

      toast.show(
        toast.KIND.SUCCESS,
        'Your email is confirmed. Please login with your newly created account.',
      );

      const params = new URLSearchParams();

      params.append('dialog', 'login');
      params.append('email', email);
      params.append('target', TARGET);

      setParams(params);
    }
  };

  return (
    <>
      <Title value='Email' />
      <Layout step='email'>
        <div className={styles.root}>

          <Formik
            initialValues={{
              code: '',
            }}
            validationSchema={yup.object({
              code: yup.string()
                .required('Required'),
            })}
            onSubmit={(values, actions) => {

              if (loading) {
                return;
              }

              setLoading(true);

              api().v1.auth.signup.confirm
                .post({
                  email,
                  code: values.code,
                })
                .then(res => {
                  setLoading(false);

                  if (res.status === 201) {
                    next();
                  }

                  if (res.status === 400) {
                    toast.show(toast.KIND.ERROR, res.body);
                  }
                })
                .catch(err => {
                  setLoading(false);
                  toast.show(toast.KIND.WARNING, err);
                });

            }} >

            <Form>
              <div>
                <label htmlFor='code'>We sent you a verification code via email 📧. Please check your inbox.</label>
                <Field
                  id='code'
                  aria-label='code'
                  name='code'
                  type='text'
                  disabled={loading}
                />
                <ErrorMessage
                  name='code'
                  component='div'
                />
                <button
                  type='button'
                  disabled={loading}
                  onClick={() => {

                    setLoading(true);

                    api().v1.auth.signup.resend
                      .post({ email })
                      .then(res => {
                        setLoading(false);

                        if (res.status === 200) {
                          toast.show(toast.KIND.SUCCESS, 'Confirmation code sent.');
                        }

                        if (res.status === 400) {
                          toast.show(toast.KIND.ERROR, res.body);
                        }
                      })
                      .catch(err => {
                        setLoading(false);
                        toast.show(toast.KIND.WARNING, err);
                      });

                  }}>

                  Re-send Code

                </button>
              </div>

              <button
                type='submit'
                disabled={loading}>

                Confirm

              </button>
            </Form>

          </Formik>

        </div>
      </Layout>
    </>
  );
};

export default _01_Email;